import * as React from "react";
import { cn } from "@/lib/utils";

export interface BrandInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  variant?: "default" | "email";
}

const BrandInput = React.forwardRef<HTMLInputElement, BrandInputProps>(
  ({ className, variant = "default", type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "w-full bg-white border-2 border-yacht-teal/30 rounded-md px-4 py-3 text-base transition-all duration-200",
          "focus:outline-none focus:border-yacht-blue focus:ring-2 focus:ring-yacht-blue/20",
          "placeholder:text-muted-foreground",
          variant === "email" && "text-lg py-4",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
BrandInput.displayName = "BrandInput";

export { BrandInput };
